function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-de4c3def-611a-4141-a9fb-f38c9679827b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m24.786,18.5h-3.859l.901-5h2.958c.828,0,1.5-.671,1.5-1.5s-.672-1.5-1.5-1.5h-2.417l.544-3.02c.147-.815-.395-1.595-1.21-1.742-.816-.152-1.595.395-1.742,1.21l-.64,3.552h-4.924l.997-5.603c.145-.815-.398-1.594-1.214-1.739-.82-.148-1.595.397-1.74,1.214l-1.091,6.128h-4.135c-.828,0-1.5.671-1.5,1.5s.672,1.5,1.5,1.5h3.602l-.89,5h-2.711c-.828,0-1.5.671-1.5,1.5s.672,1.5,1.5,1.5h2.177l-.997,5.603c-.145.815.398,1.594,1.214,1.739.089.016.177.024.265.024.713,0,1.346-.511,1.475-1.238l1.091-6.128h4.899l-.544,3.02c-.147.815.395,1.595,1.21,1.742.09.017.179.024.268.024.712,0,1.344-.509,1.475-1.234l.64-3.552h4.399c.828,0,1.5-.671,1.5-1.5s-.672-1.5-1.5-1.5Zm-11.813,0l.89-5h4.918l-.901,5h-4.906Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/Hashtag.0d374bf370638ac21993ab66e7cd2c6c.svg";
export { ForwardRef as ReactComponent };